import { render, staticRenderFns } from "./KeyboardView.vue?vue&type=template&id=f4e80320"
import script from "./KeyboardView.vue?vue&type=script&lang=js"
export * from "./KeyboardView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports